import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialer-wrapup__body" }

import { computed } from "vue";
import { useStore } from "vuex";
import { Button, Modal, Select, Textarea } from "@/components/ui";
import ActionConfirmationModal from "@/components/modal/ActionConfirmationModal.vue";
import CallSessionModal from "@/components/call/CallSessionModal.vue";
import { useCallDispositions } from "@/composables/calls";
import { createPowerDialer } from "@/composables/dialer";
import { useAIAssistant } from "@/composables/calls/useAIAssistant";


export default /*@__PURE__*/_defineComponent({
  __name: 'PowerDialerHost',
  setup(__props) {

const store = useStore();

const account = computed(() => store.getters.account.data);
const enableTranscription = computed(() => account.value?.enableTranscription !== false);

const { data: callDispositionsData } = useCallDispositions();
const callDispositions = computed(() => callDispositionsData.value || []);

const dialer = createPowerDialer();

// Only populated while the session has the AI call assistant on and a call is live.
const {
  isThinking: aiIsThinking,
  isStreaming: aiIsStreaming,
  hasSuggestions: aiHasSuggestions,
  currentStreamingText: aiStreamingText,
  suggestions: aiSuggestions,
} = useAIAssistant();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(dialer).wrapupTarget)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 0,
          show: true,
          size: "xs",
          showCloseButton: false,
          closeOnBackdrop: false,
          closeOnEscape: false
        }, {
          header: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("h2", { class: "dialer-wrapup__title" }, "Save Call Disposition", -1)
          ]))]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Please select a disposition for this call before continuing.", -1)),
              _createVNode(_unref(Select), {
                modelValue: _unref(dialer).selectedDisposition,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialer).selectedDisposition) = $event)),
                options: callDispositions.value,
                placeholder: "Choose call disposition",
                "label-key": "name",
                "value-key": "id",
                "return-object": true
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_unref(Textarea), {
                modelValue: _unref(dialer).wrapupNotes,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialer).wrapupNotes) = $event)),
                placeholder: "Notes (optional)",
                rows: 3
              }, null, 8, ["modelValue"])
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_unref(Button), {
              variant: "primary",
              disabled: !_unref(dialer).selectedDisposition || _unref(dialer).isSubmittingWrapup,
              loading: _unref(dialer).isSubmittingWrapup,
              onClick: _unref(dialer).submitWrapupForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(dialer).isSubmittingWrapup ? "Saving..." : "Save Disposition"), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(ActionConfirmationModal, {
      show: _unref(dialer).showEndSessionConfirm,
      title: "End dialer session?",
      message: "You won't be able to resume it afterward.",
      "confirm-text": "End Session",
      "cancel-text": "Cancel",
      "confirm-variant": "danger",
      "is-loading": _unref(dialer).isEndingSession,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(dialer).showEndSessionConfirm = false)),
      onConfirm: _unref(dialer).confirmEndSession
    }, null, 8, ["show", "is-loading", "onConfirm"]),
    _createVNode(CallSessionModal, {
      icps: [],
      show: _unref(dialer).showCallModal,
      contactName: _unref(dialer).currentContactName,
      to: _unref(dialer).to,
      status: _unref(dialer).callStatus,
      isPreparingAIContext: false,
      showAIPrompt: false,
      incomingCallData: null,
      formattedIncomingCallTimer: "00:00:00",
      formattedCallTimer: _unref(dialer).formattedCallTimer,
      isMuted: _unref(dialer).isMuted,
      saveRecording: _unref(dialer).saveRecording,
      enableTranscription: enableTranscription.value,
      parentCallSid: _unref(dialer).parentCallSid,
      currentCallSid: _unref(dialer).currentCallSid,
      account: account.value,
      microphones: _unref(dialer).microphones,
      speakers: _unref(dialer).speakers,
      selectedMicId: _unref(dialer).selectedMicId,
      selectedSpeakerId: _unref(dialer).selectedSpeakerId,
      isThinking: _unref(aiIsThinking),
      isStreaming: _unref(aiIsStreaming),
      hasSuggestions: _unref(aiHasSuggestions),
      currentStreamingText: _unref(aiStreamingText),
      aiSuggestions: _unref(aiSuggestions),
      onClose: _unref(dialer).handleCloseCallModal,
      onHangup: _unref(dialer).hangupCall,
      onToggleRecord: _unref(dialer).toggleRecording,
      onToggleMute: _unref(dialer).toggleMute,
      onTransferCall: _unref(dialer).handleTransfer,
      onSelectMicrophone: _unref(dialer).selectMicrophone,
      onSelectSpeaker: _unref(dialer).selectSpeaker,
      onSendDigit: _unref(dialer).sendDigit
    }, null, 8, ["show", "contactName", "to", "status", "formattedCallTimer", "isMuted", "saveRecording", "enableTranscription", "parentCallSid", "currentCallSid", "account", "microphones", "speakers", "selectedMicId", "selectedSpeakerId", "isThinking", "isStreaming", "hasSuggestions", "currentStreamingText", "aiSuggestions", "onClose", "onHangup", "onToggleRecord", "onToggleMute", "onTransferCall", "onSelectMicrophone", "onSelectSpeaker", "onSendDigit"])
  ], 64))
}
}

})